import { Spin, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { PpaScenarioActionType, PpaTableRowType } from 'types/ppa';
import type { InternalProjectRecord, InternalScenarioRecord, ScenarioRow } from '../types';
import CreateScenarioFooter from './CreateScenarioFooter';

type ExpandedScenarioRowProps = {
    projectRecord: InternalProjectRecord;
    scenarios: ScenarioRow[];
    isLoading: boolean;
    scenarioCount: number;
    childLimit?: number;
    scenarioColumns: ColumnsType<InternalScenarioRecord>;
    onCreateScenario: (projectId: number, actionType: PpaScenarioActionType) => void;
};

const ExpandedScenarioRow = ({
    projectRecord,
    scenarios,
    isLoading,
    scenarioCount,
    childLimit,
    scenarioColumns,
    onCreateScenario,
}: ExpandedScenarioRowProps) => {
    if (isLoading) {
        return (
            <div className="bg-backgroundGreyAlt min-h-[160px] flex items-center justify-center">
                <Spin />
            </div>
        );
    }

    const scenarioRows: InternalScenarioRecord[] = scenarios.map((scenario) => ({
        ...scenario,
        project_id: projectRecord.project_id,
        key: `${projectRecord.project_id}-${scenario.scenario_id}`,
        row_type: PpaTableRowType.Scenario,
    }));

    const isScenarioLimitReached = typeof childLimit === 'number' && scenarioCount >= childLimit;

    return (
        <div className="bg-[#FAFAFA]">
            <Table<InternalScenarioRecord>
                rowKey="key"
                pagination={false}
                showHeader={false}
                dataSource={scenarioRows}
                columns={scenarioColumns}
                className="price-simulator-v3-scenario-table"
            />
            <CreateScenarioFooter
                projectId={projectRecord.project_id}
                isScenarioLimitReached={isScenarioLimitReached}
                childLimit={childLimit}
                onCreateScenario={onCreateScenario}
            />
        </div>
    );
};

export default ExpandedScenarioRow;
